<template>
  <div id="pageItemList">
    <page-header></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('fleets')"
                v-model="searchInput"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="fleets"
                :rows-per-page-items="[10, 25, 50]"
                :pagination.sync="pagination"
                :total-items="fleetsCount"
                :loading="fleetIsLoading"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.dsu }}</td>
                  <td>
                    <v-btn
                      flat
                      icon
                      color="info"
                      @click="editAction(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      color="red"
                      @click="$refs.deleteDialog.deleteAction(props.item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <fleet-create-edit-dialog
      v-model="modal"
      :existingFleetIds="existingFleetIds"
      @saved="fetchItems"
    ></fleet-create-edit-dialog>

    <delete-dialog
      messageKey="deletefleet"
      ref="deleteDialog"
      @confirm="deleteConfirmation"
    ></delete-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_FLEETS,
  FETCH_FLEET,
  DELETE_FLEET,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import createButtonMixin from "@/mixins/createButton.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";
import paginationMixin from "@/mixins/pagination.mixin";
import fleetsCreateEditDialog from "@/views/fleetsCreateEditDialog.vue";

export default {
  components: {
    "fleet-create-edit-dialog": fleetsCreateEditDialog
  },
  data() {
    return {
      modal: {
        show: false,
        mode: ""
      },
      pagination: {
        sortBy: null,
        descending: false
      },
      headers: [
        { text: this.$t("number"), value: "id" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("dsu"), value: "dsu" },
        { text: this.$t("actions"), sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "fleets",
      "fleetsCount",
      "fleet",
      "fleetIsLoading",
      "createButton",
      "refreshButton"
    ]),
    existingFleetIds() {
      return this.fleets.map(fleet => fleet.id);
    }
  },
  mixins: [
    refreshButtonMixin,
    createButtonMixin,
    searchInputMixin,
    paginationMixin
  ],
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_FLEETS, [
        this.pagination,
        this.search
      ]);
    },
    createAction() {
      this.modal.mode = "create";
      this.modal.show = true;
    },
    editAction(id) {
      this.$store.dispatch(FETCH_FLEET, id).then(() => {
        this.modal.mode = "edit";
        this.modal.show = true;
      });
    },
    deleteConfirmation(fleet) {
      this.$store.dispatch(DELETE_FLEET, fleet.id).then(() => {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("deletedSuccessfully", [this.$t("fleet")]),
          color: "success"
        });

        this.fetchItems();
      });
    }
  }
};
</script>

<style scoped></style>
